export const MAX_ADULTS = 9
export const MAX_CHILDREN = 9
export const MAX_ROOMS = 5
